import { Navigate } from 'react-router';
import { Loading } from '../../components/Loading';
import { useAuth } from './AuthProvider';

/** /inici (start_url de la PWA, §10.4): agents i superadmin a «Avui»; la resta, a la home. */
export function StartRedirect() {
  const state = useAuth();
  if (state.status === 'loading' || (state.status === 'signedIn' && !state.profileReady)) return <Loading />;
  const staff = state.status === 'signedIn' && (state.activeRole === 'agent' || state.activeRole === 'superadmin');
  return <Navigate to={staff ? '/avui' : '/'} replace />;
}
